import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  MFA_SETUP_REQUEST,
  MFA_SETUP_SUCCESS,
  MFA_SETUP_FAIL,
  MFA_VERIFY_SETUP_REQUEST,
  MFA_VERIFY_SETUP_SUCCESS,
  MFA_VERIFY_SETUP_FAIL,
  MFA_VERIFY_REQUEST,
  MFA_VERIFY_SUCCESS,
  MFA_VERIFY_FAIL,
  MFA_STATUS_REQUEST,
  MFA_STATUS_SUCCESS,
  MFA_STATUS_FAIL,
  MFA_REGENERATE_REQUEST,
  MFA_REGENERATE_SUCCESS,
  MFA_REGENERATE_FAIL,
} from '../constants/userConstants';

export const userLoginReducer = (state = {}, action) => {
	switch (action.type) {
		case USER_LOGIN_REQUEST:
			return { loading: true };

		case USER_LOGIN_SUCCESS:
			return { userInfo: action.payload, loading: false };

		case USER_LOGIN_FAIL:
			return { loading: false, error: action.payload };

		case USER_LOGOUT:
			return {};

		default:
			return state;
	}
};

export const mfaSetupReducer = (state = {}, action) => {
	switch (action.type) {
		case MFA_SETUP_REQUEST:
			return { loading: true };

		case MFA_SETUP_SUCCESS:
			return { mfaSetup: action.payload, loading: false };

		case MFA_SETUP_FAIL:
			return { loading: false, error: action.payload };

		default:
			return state;
	}
};

export const mfaVerifySetupReducer = (state = {}, action) => {
	switch (action.type) {
		case MFA_VERIFY_SETUP_REQUEST:
			return { loading: true };

		case MFA_VERIFY_SETUP_SUCCESS:
			return { verifySetup: action.payload, loading: false };

		case MFA_VERIFY_SETUP_FAIL:
			return { loading: false, error: action.payload };

		default:
			return state;
	}
};

export const mfaVerifyReducer = (state = {}, action) => {
	switch (action.type) {
		case MFA_VERIFY_REQUEST:
			return { loading: true };

		case MFA_VERIFY_SUCCESS:
			return { verify: action.payload, loading: false };

		case MFA_VERIFY_FAIL:
			return { loading: false, error: action.payload };

		default:
			return state;
	}
};

export const mfaStatusReducer = (state = {}, action) => {
	switch (action.type) {
		case MFA_STATUS_REQUEST:
			return { loading: true };

		case MFA_STATUS_SUCCESS:
			return { status: action.payload, loading: false };

		case MFA_STATUS_FAIL:
			return { loading: false, error: action.payload };

		default:
			return state;
	}
};

export const mfaRegenerateReducer = (state = {}, action) => {
	switch (action.type) {
		case MFA_REGENERATE_REQUEST:
			return { loading: true };

		case MFA_REGENERATE_SUCCESS:
			return { regenerate: action.payload, loading: false };

		case MFA_REGENERATE_FAIL:
			return { loading: false, error: action.payload };

		default:
			return state;
	}
};
